export const NotificationType = {
	MEMBER_JOINED: "member_joined",
	JOIN_REQUEST: "join_request",
	JOIN_APPROVED: "join_approved",
	JOIN_REJECTED: "join_rejected",
	POST_MENTION: "post_mention",
	POST_LIKED: "post_liked",
	POST_COMMENTED: "post_commented",
	COMMENT_REPLIED: "comment_replied",
	COMMENT_LIKED: "comment_liked",
	POST_REPORTED: "post_reported",
	COMMENT_REPORTED: "comment_reported",
	POST_DELETED_BY_MOD: "post_deleted_by_mod",
	COMMENT_DELETED_BY_MOD: "comment_deleted_by_mod",
	MEMBER_REPORTED: "member_reported",
	MEMBER_BANNED: "member_banned",
	MEETING_INVITATION: "meeting_invitation",
	MEETING_CANCELLED: "meeting_cancelled",
	MEETING_UPDATED: "meeting_updated",
	MEETING_REMINDER: "meeting_reminder",
	MEETING_RESCHEDULE_REQUEST: "meeting_reschedule_request",
	EVENT_INVITED: "event_invited",
	EVENT_CANCELLED: "event_cancelled",
	EVENT_UPDATED: "event_updated",
	WAITLIST_AVAILABLE: "waitlist_available",
	GROUP_JOIN_REQUEST: "group_join_request",
	GROUP_JOIN_APPROVED: "group_join_approved",
	GROUP_JOIN_DENIED: "group_join_denied",
} as const;
export type NotificationType = (typeof NotificationType)[keyof typeof NotificationType];

export const NotificationFilter = {
	ALL: "all",
	UNREAD: "unread",
} as const;
export type NotificationFilter = (typeof NotificationFilter)[keyof typeof NotificationFilter];

export const NotificationIconKey = {
	AT_SIGN: "at_sign",
	BELL: "bell",
	CALENDAR: "calendar",
	CALENDAR_X: "calendar_x",
	CLOCK: "clock",
	HEART: "heart",
	MESSAGE_CIRCLE: "message_circle",
	SHIELD: "shield",
	SHIELD_ALERT: "shield_alert",
	USER_CHECK: "user_check",
	USER_MINUS: "user_minus",
	USER_PLUS: "user_plus",
	USER_X: "user_x",
} as const;
export type NotificationIconKey = (typeof NotificationIconKey)[keyof typeof NotificationIconKey];

export const NotificationColorKey = {
	DANGER: "danger",
	PRIMARY: "primary",
	SECONDARY: "secondary",
	WARNING: "warning",
	SUCCESS: "success",
	MUTED: "muted",
} as const;
export type NotificationColorKey = (typeof NotificationColorKey)[keyof typeof NotificationColorKey];

export const NotificationTarget = {
	FEED: "feed",
	MEETING_LIST: "meeting_list",
	MEETING_DETAIL: "meeting_detail",
	MEMBER_LIST: "member_list",
	EVENT_LIST: "event_list",
	GROUP_LIST: "group_list",
	ADMIN_GROUP_LIST: "admin_group_list",
} as const;
export type NotificationTarget = (typeof NotificationTarget)[keyof typeof NotificationTarget];
